/* eslint-disable tss-unused-classes/unused-classes -- classes are consumed by the ai360 banner components */
import { makeStyles } from 'tss-react/mui'
import ai360BannerBg from '../../../resources/ai360-extension-banner-bg.png'

type Ai360BannerStyleProps = {
  xlBackgroundOffsetY: number
  lgBackgroundOffsetY: number
}

export default makeStyles<Ai360BannerStyleProps>()((theme, { xlBackgroundOffsetY, lgBackgroundOffsetY }) => ({
  containerStyle: {
    backgroundImage: `url(${ai360BannerBg})`,
    backgroundColor: '#19290C',
    backgroundRepeat: 'no-repeat',

    [theme.breakpoints.up('xl')]: {
      /* For xl screens */
      backgroundPosition: `1163px ${xlBackgroundOffsetY}px`,
      backgroundSize: '26% 346%',
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      /* For lg screens */
      backgroundPosition: `642px ${lgBackgroundOffsetY}px`,
      backgroundSize: '33% 323%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      /* For md screens */
      backgroundPosition: '379px -78px',
      backgroundSize: '50% 304%',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      /* For sm screens */
      backgroundPosition: '267px -48px',
      backgroundSize: '73% 169%',
    },
    [theme.breakpoints.down('sm')]: {
      /* For xs screens (mobile) */
      backgroundPosition: '60px -8px',
      backgroundSize: '130% 150%',
    },
  },
  infoButton: {
    minWidth: 'max-content',
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    '&:hover': {
      borderColor: theme.palette.common.white,
    },
  },
  text: {
    color: theme.palette.common.white,
  },
  closeActionStyle: {
    color: theme.palette.common.white,
  },
}))
